"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3945],{

/***/ 60438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AddToCalendar$1; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74916);
/* harmony import */ var core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_regexp_exec_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15306);
/* harmony import */ var core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_replace_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_4__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */








var AddToCalendar = function AddToCalendar(_ref) {
  var event = _ref.event,
    onClickAdd = _ref.onClickAdd;
  var formatTime = function formatTime(date) {
    return new Date(date).toISOString().replace(/-|:|\.\d+/g, '');
  };
  var hrefGenerator = function hrefGenerator(_ref2) {
    var startTime = _ref2.startTime,
      endTime = _ref2.endTime,
      title = _ref2.title,
      description = _ref2.description;
    var start = formatTime(startTime);
    var end = formatTime(endTime);
    var href = encodeURI("data:text/calendar;charset=utf8,".concat(['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', "URL:".concat(document.URL), "DTSTART:".concat(start || ''), "DTEND:".concat(end || ''), "SUMMARY:".concat(title || ''), "DESCRIPTION:".concat(description || ''), 'END:VEVENT', 'END:VCALENDAR'].join('\n')));
    return href;
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default().createElement("div", {
    className: "quiver-add-to-calendar"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_4___default().createElement("a", {
    href: hrefGenerator(event),
    onClick: function onClick() {
      return onClickAdd();
    }
  }, "Add to Calendar"));
};
AddToCalendar.defaultProps = {
  event: {
    title: '',
    description: '',
    startTime: '',
    endtime: ''
  },
  onClickAdd: function onClickAdd() {}
};
var AddToCalendar$1 = AddToCalendar;


//# sourceMappingURL=AddToCalendar.js.map


/***/ }),

/***/ 67318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AspectRatioContent$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */




var AspectRatioContent = function AspectRatioContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-aspect-ratio-content"
  }, children);
};
var AspectRatioContent$1 = AspectRatioContent;


//# sourceMappingURL=AspectRatioContent.js.map


/***/ }),

/***/ 82019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CamOverlay$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */




var CamOverlay = function CamOverlay(_ref) {
  var children = _ref.children,
    backgroundImage = _ref.backgroundImage;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    style: {
      backgroundImage: backgroundImage
    },
    className: "quiver-cam-overlay"
  }, children);
};
CamOverlay.defaultProps = {
  backgroundImage: null
};
var CamOverlay$1 = CamOverlay;


//# sourceMappingURL=CamOverlay.js.map


/***/ }),

/***/ 92938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CamError$1; }
});

// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/node_modules/@surfline/quiver-assets/dist/index.js
var dist = __webpack_require__(20120);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/AspectRatioContent/AspectRatioContent.js
var AspectRatioContent = __webpack_require__(67318);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamOverlay/CamOverlay.js
var CamOverlay = __webpack_require__(82019);
;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/icons/CamRewindIcon/CamRewindIcon.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */



var CamRewindIcon = function CamRewindIcon() {
  return /*#__PURE__*/external_React_default().createElement("svg", {
    className: "quiver-rewind-button",
    width: "18",
    height: "18",
    viewBox: "0 0 48 48",
    fill: "rgba(255,255,255,0.8)"
  }, /*#__PURE__*/external_React_default().createElement("path", {
    d: "M22 36V12L5 24l17 12zm1-12l17 12V12L23 24z"
  }));
};
var CamRewindIcon$1 = CamRewindIcon;


//# sourceMappingURL=CamRewindIcon.js.map

;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamError/CamError.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */








var CamError = function CamError(_ref) {
  var messageData = _ref.messageData,
    rewindUrl = _ref.rewindUrl;
  return /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-error"
  }, /*#__PURE__*/external_React_default().createElement(AspectRatioContent/* default */.Z, null, /*#__PURE__*/external_React_default().createElement(CamOverlay/* default */.Z, {
    backgroundImage: "url(".concat(dist/* default */.Z, "/backgrounds/cam-down-bg-image.png)")
  }), /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-error__message"
  }, /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-error__message__text"
  }, messageData.message), /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-error__message__subtext"
  }, messageData.subMessage)), rewindUrl && /*#__PURE__*/external_React_default().createElement("a", {
    href: rewindUrl,
    className: "quiver-cam-error__cam-rewind-link"
  }, /*#__PURE__*/external_React_default().createElement(CamRewindIcon$1, null))));
};
CamError.defaultProps = {
  messageData: {
    message: 'We apologize, we are working to restore service ASAP.',
    subMessage: "The Surfline team is aware and currently working with their\n    technicians to restore service. Our Camera will return as soon as their issue\n    is resolved. Thank you for your patience."
  },
  rewindUrl: null
};
var CamError$1 = CamError;


//# sourceMappingURL=CamError.js.map


/***/ }),

/***/ 74022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CamPlayer$1; }
});

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__(12419);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(82526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(57327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(38880);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(54747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(49337);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-properties.js
var es_object_define_properties = __webpack_require__(33321);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.define-property.js
var es_object_define_property = __webpack_require__(69070);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(4942);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(21249);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(47941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(92222);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__(82772);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(74916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__(23123);
// EXTERNAL MODULE: external "React"
var external_React_ = __webpack_require__(37667);
var external_React_default = /*#__PURE__*/__webpack_require__.n(external_React_);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(32912);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(25501);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/node_modules/@surfline/quiver-assets/dist/index.js
var dist = __webpack_require__(20120);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/segment.js + 2 modules
var segment = __webpack_require__(59075);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/slugify/slugify.js
var slugify = __webpack_require__(35682);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/constants.js
var constants = __webpack_require__(72960);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/newRelicBrowser.js
var newRelicBrowser = __webpack_require__(43595);
// EXTERNAL MODULE: ./node_modules/@surfline/web-common/esm/canUseDOM.js
var canUseDOM = __webpack_require__(80660);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/camConfig.js
var camConfig = __webpack_require__(67293);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/utils/constants.js
var utils_constants = __webpack_require__(22336);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamError/CamError.js + 1 modules
var CamError = __webpack_require__(92938);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/AspectRatioContent/AspectRatioContent.js
var AspectRatioContent = __webpack_require__(67318);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamOverlay/CamOverlay.js
var CamOverlay = __webpack_require__(82019);
;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamAdBlock/CamAdBlock.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */







var CamAdblockUpsell = function CamAdblockUpsell(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    text = _ref.text;
  return /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-adblock"
  }, /*#__PURE__*/external_React_default().createElement(AspectRatioContent/* default */.Z, null, /*#__PURE__*/external_React_default().createElement(CamOverlay/* default */.Z, {
    backgroundImage: "url(".concat(dist/* default */.Z, "/backgrounds/cam-down-bg-image.png)")
  }), /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-adblock-upsell__message"
  }, /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-adblock-upsell__message__header"
  }, text.disableText), /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-adblock-upsell__message__subtext"
  }, /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-adblock-upsell__message__or"
  }, /*#__PURE__*/external_React_default().createElement("span", null, text.orText)), /*#__PURE__*/external_React_default().createElement("div", null, text.upsellText)), /*#__PURE__*/external_React_default().createElement("a", {
    href: href,
    onClick: onClick
  }, /*#__PURE__*/external_React_default().createElement("button", {
    type: "button"
  }, text.linkText)))));
};
CamAdblockUpsell.defaultProps = {
  href: null,
  onClick: null,
  text: {
    disableText: 'Please disable your ad blocker in order to view this Surfline cam.',
    orText: 'or',
    upsellText: 'For a completely ad-free cam experience',
    linkText: 'Upgrade to Premium'
  }
};
var CamAdblockUpsell$1 = CamAdblockUpsell;


//# sourceMappingURL=CamAdBlock.js.map

;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamNighttime/CamNighttime.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */






var CamNighttime = function CamNighttime(_ref) {
  var message = _ref.message,
    rewindUrl = _ref.rewindUrl,
    stillUrl = _ref.stillUrl;
  return /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-nighttime"
  }, /*#__PURE__*/external_React_default().createElement(AspectRatioContent/* default */.Z, null, /*#__PURE__*/external_React_default().createElement(CamOverlay/* default */.Z, {
    backgroundImage: "url(".concat(stillUrl, ")")
  }), /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-nighttime__message"
  }, /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-nighttime__message__header"
  }, message), /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-nighttime__message__subtext"
  }, "Enjoy a ", /*#__PURE__*/external_React_default().createElement("a", {
    href: rewindUrl
  }, "Cam Rewind")))));
};
CamNighttime.defaultProps = {
  stillUrl: '',
  message: 'Live camera stream unavailable during nighttime hours',
  rewindUrl: null
};
var CamNighttime$1 = CamNighttime;


//# sourceMappingURL=CamNighttime.js.map

;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamRewindMessage/CamRewindMessage.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */




var CamRewindMessage = function CamRewindMessage(_ref) {
  var href = _ref.href;
  return /*#__PURE__*/external_React_default().createElement("div", {
    className: "quiver-cam-rewind-message"
  }, "It's nighttime. Enjoy a ", /*#__PURE__*/external_React_default().createElement("a", {
    href: href
  }, "cam rewind"), " clip.");
};
var CamRewindMessage$1 = CamRewindMessage;


//# sourceMappingURL=CamRewindMessage.js.map

// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamTimeout/CamTimeout.js
var CamTimeout = __webpack_require__(10854);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamUpsell/CamUpsell.js
var CamUpsell = __webpack_require__(6440);
// EXTERNAL MODULE: ./node_modules/@surfline/quiver-react/esm/CountDownTimer/CountDownTimer.js
var CountDownTimer = __webpack_require__(45099);
;// CONCATENATED MODULE: ./node_modules/@surfline/quiver-react/esm/CamPlayer/CamPlayer.js
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */








































function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ALT = 'ALT';
var SUB = 'SUB';
var MSG = 'MSG';
var AUTOPLAY_DISABLED = 'disabled';
/**
 * @typedef {object} Props
 * @property {import('../PropTypes/cameras').Camera} camera
 * @property {string} location
 * @property {boolean} isFavorite
 */
/**
 * @deprecated Use the CamPlayerV2 component
 * @extends {React.Component<Props>}
 */
var CamPlayer = /*#__PURE__*/function (_Component) {
  (0,inherits/* default */.Z)(CamPlayer, _Component);
  var _super = _createSuper(CamPlayer);
  function CamPlayer(props) {
    var _this;
    (0,classCallCheck/* default */.Z)(this, CamPlayer);
    _this = _super.call(this, props);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "resetPlayerState", function () {
      return _this.setState({
        showTimeout: false,
        showUpSell: false,
        isStreaming: false,
        adCountdownTime: 0
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getStringFromParams", function (params) {
      return Object.keys(params).map(function (key) {
        return "".concat(key, "=").concat(params[key]);
      }).join('&');
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getAdTag", function (width, height) {
      var _this$state = _this.state,
        adCount = _this$state.adCount,
        midRoll = _this$state.midRoll;
      var _this$props = _this.props,
        adTag = _this$props.adTag,
        advertisingIds = _this$props.advertisingIds,
        viewType = _this$props.viewType,
        qaFlag = _this$props.qaFlag,
        isPremium = _this$props.isPremium,
        camera = _this$props.camera,
        adCamId = _this$props.adCamId;
      if (adCount > 5) return null; // Stop trying to render an ad after 5th failure
      if (adCount > 4) return "".concat(dist/* default */.Z, "/adtags/PreRoll_SLAdFreePrem_rincon_MVP_feb18.xml");
      var adTagOptions = _objectSpread(_objectSpread(_objectSpread({}, camConfig/* adTagConfig */.J), adTag), {}, {
        url: encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.hostname)),
        description_url: encodeURIComponent(window.location.href)
      });
      var verifiedCamId = adCamId === camera._id ? adCamId : null;
      var customOptions = {
        camId: verifiedCamId,
        spotid: !verifiedCamId ? advertisingIds.spotId : null,
        subregionId: advertisingIds.subregionId,
        viewtype: viewType || 'SPOT',
        qaFlag: qaFlag,
        embedUrl: window.location.href,
        usertype: isPremium ? 'premium' : 'free',
        count: adCount,
        width: width,
        height: height,
        ivp_autorefresh: midRoll ? 0 : 1
      };
      var customParams = encodeURIComponent(_this.getStringFromParams(customOptions));
      return "https://pubads.g.doubleclick.net/gampad/ads?".concat(_this.getStringFromParams(adTagOptions), "&cust_params=").concat(customParams);
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "resetMidRollState", function () {
      return _this.setState({
        midRoll: false
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "getHostedAdClassName", function () {
      var nighttime = _this.props.nighttime;
      return classnames_default()({
        'quiver-cam-player__player__host-ad': true,
        'quiver-cam-player__player__host-ad--rewind-aware': nighttime
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "onCamReady", function () {
      var _this$props2 = _this.props,
        handleCamReady = _this$props2.handleCamReady,
        camReady = _this$props2.camReady,
        setCamReady = _this$props2.setCamReady,
        autoplay = _this$props2.autoplay,
        isPremium = _this$props2.isPremium;
      var noAutoplay = autoplay === AUTOPLAY_DISABLED;
      if ((!isPremium || noAutoplay) && handleCamReady && !camReady) {
        setCamReady(true);
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "handleFirstFrame", function () {
      var _this$props3 = _this.props,
        handleCamReady = _this$props3.handleCamReady,
        controlledPlayback = _this$props3.controlledPlayback,
        camReady = _this$props3.camReady,
        setCamReady = _this$props3.setCamReady,
        isPlaying = _this$props3.isPlaying;
      if (handleCamReady && camReady !== true) {
        setCamReady(true);
      }
      if (controlledPlayback && !isPlaying) {
        _this.pausePlayer();
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "trackPlaybackEvent", function (event) {
      var isTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props4 = _this.props,
        location = _this$props4.location,
        camera = _this$props4.camera,
        spotName = _this$props4.spotName,
        isFavorite = _this$props4.isFavorite,
        spotId = _this$props4.spotId;
      (0,segment/* trackEvent */.L9)(event, {
        category: location,
        premiumCam: camera.isPremium,
        spotName: spotName,
        spotId: spotId,
        camName: camera.title,
        camId: camera._id,
        favorite: isFavorite,
        isTimeout: event === utils_constants/* STOPPED_WEBCAM */.E7 ? isTimeout : undefined
      });
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "pausePlayer", function () {
      var _this$camPlayer;
      _this.setState({
        showTimeout: false,
        isStreaming: false
      });
      if ((_this$camPlayer = _this.camPlayer) !== null && _this$camPlayer !== void 0 && _this$camPlayer.pause) {
        _this.camPlayer.pause();
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "timeoutPlayer", function () {
      var _this$camPlayer2;
      _this.setState({
        showTimeout: true,
        isStreaming: false
      });
      if ((_this$camPlayer2 = _this.camPlayer) !== null && _this$camPlayer2 !== void 0 && _this$camPlayer2.pause) {
        _this.camPlayer.pause();
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "resumePlayer", function () {
      var _this$camPlayer3;
      _this.setState({
        showTimeout: false,
        isStreaming: true
      });
      if ((_this$camPlayer3 = _this.camPlayer) !== null && _this$camPlayer3 !== void 0 && _this$camPlayer3.play) {
        _this.camPlayer.play();
      }
    });
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "camPlayerClassName", function (settings) {
      var _this$state2 = _this.state,
        showUpSell = _this$state2.showUpSell,
        showTimeout = _this$state2.showTimeout;
      var isPrerecorded = settings.isPrerecorded,
        adRunning = settings.adRunning,
        isPremium = settings.isPremium;
      return classnames_default()({
        'quiver-cam-player': true,
        'quiver-cam-player--upsell': showUpSell,
        'quiver-cam-player--timeout': showTimeout,
        'quiver-cam-player--prerecorded': isPrerecorded,
        'quiver-cam-player--ad-not-running': !adRunning,
        'quiver-cam-player--free': !isPremium
      });
    });
    _this.camPlayer = null;
    _this.adInterval = 30;
    _this.upsellDuration = 15; // Seconds
    _this.premiumTimeout = 600; // 10 minute premium timeout
    _this.camWidth = null;
    _this.state = {
      showTimeout: false,
      showUpSell: false,
      isStreaming: false,
      adFreePopup: false,
      adCount: 1,
      adRunning: false,
      controlsVisible: true,
      notFoundCount: 0,
      networkError: {
        isDown: false,
        message: null,
        altMessage: null
      },
      midRoll: false
    };
    return _this;
  }
  (0,createClass/* default */.Z)(CamPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props5 = this.props,
        adblock = _this$props5.adblock,
        onDetectedAdBlock = _this$props5.onDetectedAdBlock;
      if (adblock && onDetectedAdBlock) {
        onDetectedAdBlock();
      }
      this.setupPlayer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props6 = this.props,
        camera = _this$props6.camera,
        adblock = _this$props6.adblock,
        onDetectedAdBlock = _this$props6.onDetectedAdBlock,
        onToggleStreaming = _this$props6.onToggleStreaming,
        controlledPlayback = _this$props6.controlledPlayback,
        isPlaying = _this$props6.isPlaying;
      var _this$state3 = this.state,
        isStreaming = _this$state3.isStreaming,
        midRoll = _this$state3.midRoll;
      if (camera && camera.streamUrl !== prevProps.camera.streamUrl) {
        if (midRoll) this.resetMidRollState();
        this.resetPlayerState();
        this.setupPlayer();
      }
      if (!prevProps.adblock && adblock && onDetectedAdBlock) {
        onDetectedAdBlock();
      }
      if (onToggleStreaming && isStreaming !== prevState.isStreaming) {
        onToggleStreaming(isStreaming);
      }
      if (controlledPlayback) {
        if (isPlaying !== prevProps.isPlaying) {
          if (isPlaying) {
            this.resumePlayer();
          } else {
            this.pausePlayer();
          }
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.camPlayer && this.camPlayer.remove) this.camPlayer.remove();
      var isStreaming = this.state.isStreaming;
      if (isStreaming) {
        this.trackPlaybackEvent(utils_constants/* STOPPED_WEBCAM */.E7);
      }
    }
  }, {
    key: "getRewindUrl",
    value: function getRewindUrl() {
      var _this$props7 = this.props,
        spotName = _this$props7.spotName,
        camera = _this$props7.camera;
      // If no spotName has been passed then try the camera title just so there's something in there
      // defaults to the first spot associated with the cam id anyway so not really required, defaults to
      // rewind incase there's no title either.
      return "/surf-cams/".concat((0,slugify/* default */.Z)(spotName || camera.title || 'rewind'), "/").concat(camera._id);
    }
  }, {
    key: "setupPlayer",
    value: function setupPlayer() {
      var _this2 = this;
      if (window && window.jwplayer) {
        var _this$props8 = this.props,
          nighttime = _this$props8.nighttime,
          rewindClip = _this$props8.rewindClip,
          playerId = _this$props8.playerId,
          camera = _this$props8.camera,
          isPremium = _this$props8.isPremium,
          isPersistentCam = _this$props8.isPersistentCam,
          aspectRatio = _this$props8.aspectRatio,
          companionHandler = _this$props8.companionHandler,
          spotId = _this$props8.spotId,
          spotName = _this$props8.spotName,
          onTogglePreRoll = _this$props8.onTogglePreRoll,
          isMultiCam = _this$props8.isMultiCam,
          isPrimaryCam = _this$props8.isPrimaryCam,
          timeoutMultiCams = _this$props8.timeoutMultiCams,
          setCamReady = _this$props8.setCamReady,
          handleCamReady = _this$props8.handleCamReady,
          camReady = _this$props8.camReady,
          controlledAds = _this$props8.controlledAds,
          playbackRateControls = _this$props8.playbackRateControls;
        var _this$state4 = this.state,
          adCount = _this$state4.adCount,
          notFoundCount = _this$state4.notFoundCount;
        window.jwplayer.key = window.jwplayer.defaults.key;
        this.camPlayer = window.jwplayer(playerId);
        this.rewindClipError = false;
        var isPrerecorded = camera.isPrerecorded;
        var rewindUrl = this.getRewindUrl();
        if (!this.camPlayer.setup) return;
        var file = nighttime && rewindClip ? rewindClip : camera.streamUrl;
        var cookie = new Cookies/* default */.Z();
        var accessToken = cookie.get('access_token');

        /* istanbul ignore next */
        if (accessToken) {
          file += "?accessToken=".concat(accessToken);
        }
        var withCredentials = file.indexOf('authorization') > -1;
        /* istanbul ignore next */
        this.camPlayer.setup(_objectSpread({
          file: file,
          type: file.indexOf('mp4') > -1 ? 'mp4' : 'hls',
          withCredentials: withCredentials,
          image: camera.stillUrl,
          aspectratio: aspectRatio
        }, (0,camConfig/* setupConfig */.q)(isPremium || isPersistentCam || isPremium && isMultiCam, playbackRateControls)));
        if (!isPrerecorded && rewindUrl) {
          /* istanbul ignore next */
          this.camPlayer.addButton("<svg\n            class=\"rewind-button\"\n            xmlns=\"http://www.w3.org/2000/svg\"\n            width=\"18\"\n            height=\"18\"\n            viewBox=\"0 0 48 48\"\n            fill=\"rgba(255,255,255,0.8)\"\n            >\n            <path d=\"M22 36V12L5 24l17 12zm1-12l17 12V12L23 24z\"/>\n          </svg>", 'Cam Rewind', function () {
            (0,segment/* trackEvent */.L9)('Clicked Cam Rewind', {
              spotId: spotId,
              spotName: spotName,
              location: 'cam player',
              camId: camera._id,
              camName: camera.title,
              premiumCam: camera.isPremium,
              isMobileView: window.innerWidth < constants/* TABLET_LARGE_WIDTH */.zu,
              platform: 'web'
            });
            window.location.href = rewindUrl;
          }, 'contents', 'jw-cam-rewind');
        }
        if (nighttime && rewindClip) {
          /* istanbul ignore next */
          this.camPlayer.on('error', function () {
            _this2.rewindClipError = true;
            _this2.camPlayer.load({
              file: camera.streamUrl,
              withCredentials: camera.streamUrl.indexOf('authorization') > -1,
              image: camera.stillUrl
            });
          });
        }

        /* istanbul ignore next */
        this.camPlayer.on('userInactive', function () {
          _this2.setState({
            controlsVisible: false
          });
        });

        /* istanbul ignore next */
        this.camPlayer.on('userActive', function () {
          _this2.setState({
            controlsVisible: true
          });
        });

        // fires preRoll Ad.
        if (!isPremium && !this.rewindClipError && !controlledAds) {
          /* istanbul ignore next */
          this.camPlayer.on('beforePlay', function () {
            _this2.playAd();
            _this2.setState({
              adRunning: true
            });
            if (_this2.rewindClipError) _this2.rewindClipError = false;
            if (onTogglePreRoll) onTogglePreRoll(true);
          });
        }

        /* istanbul ignore next */
        this.camPlayer.on('adTime', function (obj) {
          _this2.setState({
            adCountdownTime: Math.round(obj.duration - obj.position)
          });
        });

        // executes adError waterfall.
        /* istanbul ignore next */
        this.camPlayer.on('adError', function () {
          _this2.setState(function (prevState) {
            return {
              adCount: prevState.adCount + 1
            };
          });
          if (adCount <= 5) {
            _this2.playAd();
          } else {
            _this2.resumePlayer(); // if an ad fails to load more than 5 times, play the camera.
          }
        });

        /* istanbul ignore next */
        this.camPlayer.on('error', function (error) {
          // If error isn't due to ads, proceed with network error handling
          if (adCount > 5 || error.code) {
            var networkError = {
              isDown: true,
              message: "We're sorry to report that this camera is down.\n            The Surfline team is aware of the issue and is currently working toward a resolution.",
              subMessage: null,
              altMessage: 'Camera Down'
            };
            _this2.setState({
              networkError: networkError
            });
            // if chunklist sends a 404, wait 1 second and resume play
            if (error.message.indexOf('404') > -1 || error.code === 232404 || error.code === 232001) {
              _this2.setState(function (prevState) {
                return {
                  notFoundCount: prevState.notFoundCount + 1
                };
              });
              if (notFoundCount <= 10) {
                _this2.setState({
                  networkError: {
                    isDown: true,
                    message: 'Refreshing camera stream'
                  }
                });
                setTimeout(function () {
                  _this2.setupPlayer();
                }, 1000);
              } else {
                (0,newRelicBrowser/* nrNoticeError */.lb)(error, _this2.camera);
              }
            }
          }

          /* istanbul ignore next */
          if (handleCamReady && camReady !== true) {
            setCamReady(true);
          }
        });

        // sends companion ad styles and html up to parent
        if (companionHandler) {
          this.camPlayer.on('adCompanions', function (event) {
            companionHandler(event.companions);
          });
        }

        // restarts the cam stream when ad finishes.
        /* istanbul ignore next */
        this.camPlayer.on('adComplete', function () {
          _this2.setState({
            showTimeout: false,
            adCount: 1,
            adRunning: false
          });
          if (onTogglePreRoll) onTogglePreRoll(false);
        });

        // resets the adError waterfall count.
        /* istanbul ignore next */
        this.camPlayer.on('play', function () {
          _this2.setState({
            isStreaming: true
          });
          _this2.trackPlaybackEvent(utils_constants/* PLAYED_WEBCAM */.kb);
        });

        /* istanbul ignore next */
        this.camPlayer.on('pause', function () {
          var showTimeout = _this2.state.showTimeout;
          _this2.setState({
            isStreaming: false
          });
          _this2.trackPlaybackEvent(utils_constants/* STOPPED_WEBCAM */.E7, showTimeout);
        });

        // coordinates mid roll ad chain
        var timeElapsed = 0;
        var currentTime = 0;

        /* istanbul ignore next */
        this.camPlayer.on('time', function (event) {
          var playerPosition = Math.round(event.position);
          /*
            Because this Event is fired multiple times (<=10) a second,
            this conditional is required for tracking total seconds played.
          */
          if (playerPosition !== currentTime) {
            currentTime = playerPosition;
            timeElapsed += 1;
          }
          if (!isPremium && timeElapsed === _this2.adInterval) {
            timeElapsed = 0;
            _this2.playMidrollAds();
          } else if (timeElapsed >= _this2.premiumTimeout) {
            if (!isMultiCam) {
              _this2.timeoutPlayer();
            } else {
              _this2.trackPlaybackEvent(utils_constants/* STOPPED_WEBCAM */.E7);
              if (isPrimaryCam) {
                timeoutMultiCams();
              }
            }
            timeElapsed = 0;
          }
        });

        /* istanbul ignore next */
        this.camPlayer.on('firstFrame', this.handleFirstFrame);

        /* istanbul ignore next */
        this.camPlayer.on('ready', this.onCamReady);
      }
    }
  }, {
    key: "messageConfig",
    value: function messageConfig() {
      var _this$props9 = this.props,
        camera = _this$props9.camera,
        messageType = _this$props9.messageType,
        isClip = _this$props9.isClip;
      var status = camera.status;
      var networkError = this.state.networkError;
      var showSubMessage = messageType === SUB;
      if (isClip) {
        return {
          camStatusMessage: {
            message: status.message,
            subMessage: null
          },
          camDownMessage: {
            message: status.message,
            subMessage: null
          }
        };
      }
      var messageData = {
        camStatusMessage: {
          message: messageType === ALT ? status.altMessage : status.message,
          subMessage: showSubMessage ? status.subMessage : null
        },
        camDownMessage: {
          message: messageType === ALT ? networkError.altMessage : networkError.message,
          subMessage: showSubMessage ? networkError.subMessage : null
        }
      };
      return messageData;
    }

    // Midroll daisychain: 30-15-30
  }, {
    key: "playMidrollAds",
    value: function playMidrollAds() {
      var _this3 = this;
      var onToggleMidRoll = this.props.onToggleMidRoll;
      this.setState({
        showUpSell: true,
        midRoll: true
      });
      this.pausePlayer();
      if (onToggleMidRoll) onToggleMidRoll(true);
      setTimeout(function () {
        _this3.setState({
          showUpSell: false,
          adFreePopup: true
        });
        _this3.resumePlayer();
        if (onToggleMidRoll) onToggleMidRoll(false);
      }, this.upsellDuration * 1000);
    }
  }, {
    key: "playAd",
    value: function playAd() {
      var isPersistentCam = this.props.isPersistentCam;
      if (isPersistentCam) {
        return;
      }
      var playerWidth = this.camPlayer.getWidth();
      var playerHeight = this.camPlayer.getHeight();
      var adTag = this.getAdTag(playerWidth, playerHeight);
      if (adTag) this.camPlayer.playAd(adTag);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props10 = this.props,
        cssModules = _this$props10.cssModules,
        nighttime = _this$props10.nighttime,
        rewindClip = _this$props10.rewindClip,
        adCountdown = _this$props10.adCountdown,
        camera = _this$props10.camera,
        playerId = _this$props10.playerId,
        adblock = _this$props10.adblock,
        onClickUpSell = _this$props10.onClickUpSell,
        onClickAdBlock = _this$props10.onClickAdBlock,
        onDetectedAdBlock = _this$props10.onDetectedAdBlock,
        funnelUrl = _this$props10.funnelUrl,
        camHostAd = _this$props10.camHostAd,
        showOverlays = _this$props10.showOverlays,
        isMultiCam = _this$props10.isMultiCam,
        prerecordedTimeRange = _this$props10.prerecordedTimeRange,
        handleCamReady = _this$props10.handleCamReady,
        camReady = _this$props10.camReady,
        setCamReady = _this$props10.setCamReady,
        isPremium = _this$props10.isPremium,
        adFreePopupText = _this$props10.adFreePopupText,
        playbackRateControls = _this$props10.playbackRateControls;
      var _this$state5 = this.state,
        showTimeout = _this$state5.showTimeout,
        showUpSell = _this$state5.showUpSell,
        isStreaming = _this$state5.isStreaming,
        adCountdownTime = _this$state5.adCountdownTime,
        networkError = _this$state5.networkError,
        adRunning = _this$state5.adRunning,
        controlsVisible = _this$state5.controlsVisible,
        adFreePopup = _this$state5.adFreePopup;
      var status = camera.status;
      var rewindUrl = this.getRewindUrl();

      // This is to remove 'SOCAL - ' from camera name
      var cameraTitle = camera.title ? camera.title : '';
      var parsedCameraTitle = cameraTitle.indexOf('- ') !== -1 ? cameraTitle.split('- ')[1] : cameraTitle;
      var prerecordedStart = prerecordedTimeRange.start && (0,format/* default */.Z)(new Date(prerecordedTimeRange.start), 'hh:mm');
      var prerecordedEnd = prerecordedTimeRange.end && (0,format/* default */.Z)(new Date(prerecordedTimeRange.end), 'hh:mma');
      var isPrerecorded = camera.isPrerecorded;
      var isLive = camera.streamUrl && camera.streamUrl.indexOf('.mp4') === -1;
      var messageData = this.messageConfig();
      var isDown = status.isDown || networkError.isDown;
      if (isDown && handleCamReady && camReady !== true) {
        setCamReady(true);
      }
      if (status.isDown || networkError.isDown) {
        return /*#__PURE__*/external_React_default().createElement(CamError/* default */.Z, {
          messageData: status.isDown ? messageData.camStatusMessage : messageData.camDownMessage,
          rewindUrl: rewindUrl
        });
      }
      if (adblock && onDetectedAdBlock) {
        return /*#__PURE__*/external_React_default().createElement(CamAdblockUpsell$1, {
          href: funnelUrl,
          onClick: onClickAdBlock,
          onMount: onDetectedAdBlock,
          rewindUrl: rewindUrl
        });
      }
      if (nighttime && !rewindClip) {
        return /*#__PURE__*/external_React_default().createElement(CamNighttime$1, {
          stillUrl: camera.stillUrl,
          rewindUrl: rewindUrl,
          nighttime: nighttime
        });
      }
      return /*#__PURE__*/external_React_default().createElement("div", {
        className: this.camPlayerClassName({
          isPrerecorded: isPrerecorded,
          adRunning: adRunning,
          isPremium: isPremium
        })
      }, adFreePopup && adFreePopupText && !isPremium ? /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player--free__ad-free-popup"
      }, /*#__PURE__*/external_React_default().createElement("h3", null, adFreePopupText.headline), /*#__PURE__*/external_React_default().createElement("p", null, adFreePopupText.message), /*#__PURE__*/external_React_default().createElement("div", null, /*#__PURE__*/external_React_default().createElement("button", {
        type: "button",
        onClick: function onClick() {
          _this4.setState({
            adFreePopup: false
          });
        }
      }, adFreePopupText.decline)), /*#__PURE__*/external_React_default().createElement("div", null, /*#__PURE__*/external_React_default().createElement("a", {
        href: funnelUrl,
        onClick: function onClick() {
          _this4.setState({
            adFreePopup: false
          });
        }
      }, adFreePopupText.accept))) : null, adCountdown ? /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player__countdown"
      }, adCountdownTime ? /*#__PURE__*/external_React_default().createElement("span", null, "This ad will end in", adCountdownTime, " seconds") : null) : null, /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player__player ".concat(playbackRateControls ? 'quiver-cam-player__player--show-settings' : '')
      }, showOverlays && /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player__player__overlays"
      }, /*#__PURE__*/external_React_default().createElement("div", {
        style: {
          display: isStreaming ? 'block' : 'none'
        },
        className: this.getHostedAdClassName()
      }, camHostAd), isMultiCam ? /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player__player__overlays__cam-title"
      }, parsedCameraTitle) : null), !adRunning && /*#__PURE__*/external_React_default().createElement("div", null, isPrerecorded && prerecordedStart && !isLive && /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player__player__recorded-earlier"
      }, "Recorded Earlier\xA0\xA0|\xA0\xA0", prerecordedStart, " - ", prerecordedEnd), isLive && !isPrerecorded && controlsVisible && isStreaming && /*#__PURE__*/external_React_default().createElement("div", {
        className: "quiver-cam-player__player__live"
      }, /*#__PURE__*/external_React_default().createElement("span", null, "\u2022"), " Live")), nighttime && isStreaming && rewindUrl ? /*#__PURE__*/external_React_default().createElement(CamRewindMessage$1, {
        href: rewindUrl
      }) : null, /*#__PURE__*/external_React_default().createElement(AspectRatioContent/* default */.Z, null, showTimeout ? /*#__PURE__*/external_React_default().createElement(CamTimeout/* default */.Z, {
        stillUrl: camera.stillUrl,
        onClick: this.resumePlayer
      }) : null, showUpSell ? /*#__PURE__*/external_React_default().createElement("div", null, /*#__PURE__*/external_React_default().createElement(CamUpsell/* default */.Z, {
        href: funnelUrl,
        onClick: onClickUpSell,
        stillUrl: camera.stillUrl,
        cssModules: cssModules
      }), /*#__PURE__*/external_React_default().createElement("div", {
        className: cssModules['quiver-cam-player__upsell-countdown'] || 'quiver-cam-player__upsell-countdown'
      }, "Next ad will start in", ' ', /*#__PURE__*/external_React_default().createElement(CountDownTimer/* default */.Z, {
        countTime: this.upsellDuration
      }), " seconds")) : null, /*#__PURE__*/external_React_default().createElement("div", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
          __html: "<div id=\"".concat(playerId, "\"></div>")
        }
      }))));
    }
  }]);
  return CamPlayer;
}(external_React_.Component);
CamPlayer.defaultProps = {
  adFreePopupText: null,
  nighttime: false,
  rewindClip: null,
  adCountdown: false,
  companionHandler: null,
  aspectRatio: '16:9',
  onClickAdBlock: null,
  onClickUpSell: null,
  onDetectedAdBlock: null,
  onToggleMidRoll: null,
  onTogglePreRoll: null,
  onToggleStreaming: null,
  funnelUrl: null,
  advertisingIds: {
    spotId: null,
    subregionId: null
  },
  isPremium: true,
  isPersistentCam: false,
  adblock: false,
  spotName: null,
  spotId: null,
  viewType: null,
  adTag: null,
  camHostAd: /*#__PURE__*/external_React_default().createElement("div", null),
  qaFlag: null,
  showOverlays: true,
  timeoutMultiCams: function timeoutMultiCams() {
    return null;
  },
  isMultiCam: false,
  isPrimaryCam: false,
  messageType: MSG,
  isClip: false,
  prerecordedTimeRange: {
    start: null,
    end: null
  },
  setCamReady: function setCamReady() {
    return null;
  },
  controlledPlayback: false,
  camReady: false,
  isPlaying: false,
  handleCamReady: false,
  autoplay: null,
  cssModules: {},
  controlledAds: false,
  adCamId: null,
  playbackRateControls: false,
  location: canUseDOM/* default */.Z && window.location.pathname,
  isFavorite: false
};
var CamPlayer$1 = CamPlayer;


//# sourceMappingURL=CamPlayer.js.map


/***/ }),

/***/ 10854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CamTimeout$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CamOverlay_CamOverlay_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82019);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */





var CamTimeout = function CamTimeout(_ref) {
  var stillUrl = _ref.stillUrl,
    onClick = _ref.onClick,
    text = _ref.text,
    isMultiCam = _ref.isMultiCam;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-cam-timeout"
  }, !isMultiCam && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_CamOverlay_CamOverlay_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    backgroundImage: "url(".concat(stillUrl, ")")
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-cam-timeout__message"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", null, text.message), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    onClick: onClick
  }, text.linkText)));
};
CamTimeout.defaultProps = {
  isMultiCam: false,
  stillUrl: '',
  text: {
    message: 'Are you still watching?',
    linkText: 'continue watching'
  }
};
var CamTimeout$1 = CamTimeout;


//# sourceMappingURL=CamTimeout.js.map


/***/ }),

/***/ 6440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CamUpsell$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CamOverlay_CamOverlay_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82019);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */





var CamUpsell = function CamUpsell(_ref) {
  var stillUrl = _ref.stillUrl,
    href = _ref.href,
    onClick = _ref.onClick,
    text = _ref.text,
    cssModules = _ref.cssModules;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: cssModules['quiver-cam-upsell'] || 'quiver-cam-upsell'
  }, stillUrl && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_CamOverlay_CamOverlay_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    backgroundImage: "url(".concat(stillUrl, ")")
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-cam-upsell__message"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "quiver-cam-upsell__message__header"
  }, text.primary), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", {
    href: href,
    onClick: onClick
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button"
  }, text.link)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: cssModules['quiver-cam-upsell__message__subtext'] || 'quiver-cam-upsell__message__subtext',
    dangerouslySetInnerHTML: {
      __html: text.secondary
    }
  })));
};
CamUpsell.defaultProps = {
  stillUrl: null,
  href: null,
  onClick: null,
  text: {
    primary: 'Watch waves, not ads. Start your free trial now.',
    link: 'START FREE TRIAL',
    secondary: "To watch for 30 more seconds,".concat(' ', "\n    <a href=\"#\" onClick=\"window.location.reload(true)\">refresh the camera</a>.")
  },
  cssModules: {}
};
var CamUpsell$1 = CamUpsell;


//# sourceMappingURL=CamUpsell.js.map


/***/ }),

/***/ 67293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ adTagConfig; },
/* harmony export */   "q": function() { return /* binding */ setupConfig; }
/* harmony export */ });
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */

var setupConfig = function setupConfig() {
  var autoStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var playbackRateControls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    primary: 'html5',
    width: '100%',
    hlshtml: true,
    androidhls: true,
    skin: 'five',
    autostart: autoStart,
    mute: autoStart,
    // Safari prevents un-muted cams from auto-play
    advertising: {
      client: 'googima'
    },
    liveTimeout: 0,
    playbackRateControls: playbackRateControls
  };
};
var adTagConfig = {
  sz: '1280x720|640x480',
  iu: '/1024858/Video_Companion',
  ciu_szs: '300x250,320x50',
  impl: 's',
  gdfp_req: '1',
  env: 'vp',
  output: 'vast',
  unviewed_position_start: '1',
  correlator: Math.floor(new Date() / 1000)
};


//# sourceMappingURL=camConfig.js.map


/***/ }),

/***/ 45099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CountDownTimer$1; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12419);
/* harmony import */ var core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_reflect_construct_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60136);
/* harmony import */ var _babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82963);
/* harmony import */ var _babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61120);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */










function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_esm_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_esm_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CountDownTimer = /*#__PURE__*/function (_Component) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CountDownTimer, _Component);
  var _super = _createSuper(CountDownTimer);
  function CountDownTimer(props) {
    var _this;
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, CountDownTimer);
    _this = _super.call(this, props);
    _this.state = {
      currentCount: props.countTime
    };
    return _this;
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CountDownTimer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.intervalId = setInterval(this.timer.bind(this), 1000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: "timer",
    value: function timer() {
      var onCountdownComplete = this.props.onCountdownComplete;
      this.setState(function (prevState) {
        return {
          currentCount: prevState.currentCount - 1
        };
      });
      var currentCount = this.state.currentCount;
      if (currentCount < 1) {
        clearInterval(this.intervalId);
        onCountdownComplete();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var currentCount = this.state.currentCount;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", null, currentCount);
    }
  }]);
  return CountDownTimer;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
CountDownTimer.defaultProps = {
  countTime: 0,
  onCountdownComplete: function onCountdownComplete() {}
};
var CountDownTimer$1 = CountDownTimer;


//# sourceMappingURL=CountDownTimer.js.map


/***/ }),

/***/ 55560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PremiumCamCTA$1; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Button_Button_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25874);
/* harmony import */ var _icons_PremiumCamIconMedium_PremiumCamIconMedium_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20298);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */















function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultCopy = {
  indicatorText: 'premium cam',
  headerText: 'This is a High Resolution, Premium Only Cam',
  subheaderText: 'Watch live conditions of this spot in full HD, ad-free',
  ctaText: 'Start Free Trial',
  learnMoreText: 'Learn more about Surfline Premium'
};
var PremiumCamCTA = function PremiumCamCTA(_ref) {
  var href = _ref.href,
    onClickPaywall = _ref.onClickPaywall,
    camStillUrl = _ref.camStillUrl,
    copy = _ref.copy,
    Icon = _ref.Icon;
  var onClickGoPremium = function onClickGoPremium() {
    onClickPaywall();
    window.location.assign(href);
  };
  var fullCopy = _objectSpread(_objectSpread({}, defaultCopy), copy);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__camStill",
    style: {
      backgroundImage: "url(".concat(camStillUrl, ")")
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-aspect-ratio-content quiver-premium-cam-cta__content__container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__content"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__heading"
  }, fullCopy.headerText), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__icon"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(Icon, null)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__subheading"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("span", null, fullCopy.subheaderText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__links"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__links__upgrade"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement(_Button_Button_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    onClick: onClickGoPremium
  }, fullCopy.ctaText)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("div", {
    className: "quiver-premium-cam-cta__links__about"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_8___default().createElement("a", {
    href: "/premium-benefits"
  }, fullCopy.learnMoreText)))))));
};
PremiumCamCTA.defaultProps = {
  href: null,
  onClickPaywall: null,
  camStillUrl: null,
  copy: null,
  Icon: _icons_PremiumCamIconMedium_PremiumCamIconMedium_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z
};
var PremiumCamCTA$1 = PremiumCamCTA;


//# sourceMappingURL=PremiumCamCTA.js.map


/***/ }),

/***/ 20298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PremiumCamIconMedium$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */



/* eslint-disable max-len */
var PremiumCamIconMedium = function PremiumCamIconMedium() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "27",
    viewBox: "0 0 24 27"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: "1.152"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    d: "M.576.576v25.541L12 21.088l11.424 5.03V.575H.576z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    stroke: "#22D737",
    fill: "#22D737",
    d: "M18.286 8.951v5.42l-2.794-1.458v1.638c0 .392-.315.71-.704.71h-8.37a.707.707 0 0 1-.704-.71V8.928c0-.393.316-.71.704-.71h8.37c.389 0 .704.317.704.71v1.48l2.794-1.457z"
  })));
};
var PremiumCamIconMedium$1 = PremiumCamIconMedium;


//# sourceMappingURL=PremiumCamIconMedium.js.map


/***/ }),

/***/ 95963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PremiumTagLarge$1; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37667);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */




/* eslint-disable */
var PremiumTagLarge = function PremiumTagLarge(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    width: "20px",
    height: "25px",
    viewBox: "0 0 24 30",
    className: className
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "Premium-only-stories",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("g", {
    id: "desktop---wp-paywall",
    transform: "translate(-315.000000, -1384.000000)",
    fill: "#22D737",
    fillRule: "nonzero"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M317,1384 L337,1384 C338.104569,1384 339,1384.89543 339,1386 L339,1414 L327,1408.57339 L315,1414 L315,1386 C315,1384.89543 315.895431,1384 317,1384 Z",
    id: "Rectangle-Copy-14"
  }))));
};
PremiumTagLarge.defaultProps = {
  className: ''
};
var PremiumTagLarge$1 = PremiumTagLarge;


//# sourceMappingURL=PremiumTagLarge.js.map


/***/ }),

/***/ 22336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E7": function() { return /* binding */ STOPPED_WEBCAM; },
/* harmony export */   "Ef": function() { return /* binding */ MAX_PASSWORD_LENGTH; },
/* harmony export */   "Kt": function() { return /* binding */ CLICKED_SUBSCRIBE_CTA; },
/* harmony export */   "kb": function() { return /* binding */ PLAYED_WEBCAM; },
/* harmony export */   "lo": function() { return /* binding */ MIN_PASSWORD_LENGTH; }
/* harmony export */ });
/* unused harmony exports TREATMENT_WRAPPER_CLASS, TREATMENT_WRAPPER_LOADING_CLASS */
/**
 * @surfline/quiver-react v23.15.0 2023-08-09
 */

var TREATMENT_WRAPPER_CLASS = 'quiver-treatment-wrapper';
var TREATMENT_WRAPPER_LOADING_CLASS = "".concat(TREATMENT_WRAPPER_CLASS, "--loading");
var PLAYED_WEBCAM = 'Played Webcam';
var STOPPED_WEBCAM = 'Stopped Webcam';
var CLICKED_SUBSCRIBE_CTA = 'Clicked Subscribe CTA';
var MIN_PASSWORD_LENGTH = 6;
var MAX_PASSWORD_LENGTH = 50;


//# sourceMappingURL=constants.js.map


/***/ })

}]);